import React, {Component} from "react";
import "./MainStyles.css"
import Markets from "../Markets";
import DisplayScreens from "../DisplayScreens";
import Fade from 'react-reveal/Fade'
import Warning from "../warning/Warning";


class Main extends Component{
    constructor() {
        super();
        this.flagBox = React.createRef();
        this.flag = React.createRef();
        this.flagText = React.createRef();
        this.flagTextValue = React.createRef();
        this.flagAnimation = this.flagAnimation.bind();
    }

    flagAnimation = () => {
        let flBox = this.flagBox.current;
        let fl = this.flag.current;
        let flText = this.flagText.current;
        let flTextVal = this.flagTextValue.current;
        flBox.classList.add("_active_box");
        fl.classList.add("_active-flag");
        flText.classList.add("_active_text");
        setTimeout(() => {flTextVal.classList.add("flag-text_value_active")}, 2000);
    }


    render() {
            return(
                <div className={"main"}>
                    <Warning/>
                    <div className={"info-container"}>
                        <Fade duration={3000}>
                            <div className={"mobile-app-image"}>
                            <div className={"mobile-app-image-box"}>
                                <div className={"display-screen"}>
                                    <img className={"display-screen_image"} src={process.env.PUBLIC_URL + `./main/CN_1st2.png`} alt={"Logo"} onLoad={() => this.flagAnimation()}/>
                                </div>
                            </div>
                            </div>
                            <div className={"mobile-app-info"}>
                                <h1 className={"mobile-app-info_title"}>Социальный навигатор</h1>
                                <p className={"mobile-app-info_subtitle"}>Мобильное приложение<br/> Социального фонда России</p>
                                <div className={"mobile-app-info-box"}>
                                    <div ref={this.flagBox} className={"mobile-app-info_flag"}>
                                        <div className={"flag-text"} ref={this.flagText}>
                                            <p ref={this.flagTextValue} className={"flag-text_value"}> Вся информация о Ваших больничных и пособиях всегда под рукой!</p>
                                        </div>
                                        <div ref={this.flag} className={"flag"}></div>
                                    </div>
                                    <div className={"mobile-app-image mobile"}>
                                        <div className={"mobile-app-image-box mobile-box"}>
                                            <div className={"display-screen"}>
                                                <img className={"display-screen_image"} ref={this.image} src={process.env.PUBLIC_URL + `./main/CN_1st2.png`}/>
                                            </div>
                                        </div>
                                    </div>
                                    {/*<Markets />*/}
                                </div>
                            </div>
                        </Fade>
                    </div>
                </div>
            );


    }
}
export default Main;